<template>
  <!-- Navbar Start -->
  <nav class="navbar navbar-expand-md bg-inverse fixed-top scrolling-navbar">
    <div class="container ">
      <!-- Brand and toggle get grouped for better mobile display -->
      <a href="#" class="navbar-brand">
        <img src="../assets/img/iranologyFoundation.svg" class="mrWidth" alt="بنیاد ایران شناسی">
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
              aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <i class="lni-menu"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mr-auto w-100 justify-content-end clearfix">
          <li class="nav-item active">
            <a class="nav-link text-right" href="#">
              صفحه نخست
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-right" href="#week">
              برنامه هفتگی
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-right" href="#forms">
              فرم ها
            </a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">
              خدمات
              <i class="lni lni-angle-double-down" style="font-size: 10px;"></i>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item text-right" v-for="(service, id) in myServices" :key="id"  :href="service.link" target="_blank">
                {{service.title}}
              </a>
              <!--              <a class="dropdown-item text-right" href="#">خدمات</a>-->
              <!--              <div class="dropdown-divider"></div>-->
              <!--              <a class="dropdown-item text-right" href="#">خدمات</a>-->
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link text-right" href="#team">
              مدیریت
            </a>
          </li>
          <li class="nav-item ">
            <a class="nav-link text-right " href="#us">
              ارتباط با ما
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- Navbar End -->

</template>

<script>
import {services} from '@/Data/servicesData'

export default {
  name: "MrNavbar",
  data() {
    return {
      myServices: services,
    }
  }
}
</script>

<style scoped>
.mrWidth {
  width: 200px !important;
}

ul li {
  padding-right: 10px;
}
</style>